import React, { createRef } from "react";

class FadeUpOnScroll extends React.Component {
  constructor(props) {
    super(props);
    this.ref = createRef();
    this.state = { visible: false };
  }

  componentDidMount() {
    if (this.props.enabled === false) {
      return;
    }
    // Start hidden
    if (this.ref.current) {
      this.ref.current.style.opacity = 0;
    }

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.setState({ visible: true });
          this.observer.unobserve(this.ref.current);
        }
      },
      { threshold: 0.1 }
    );

    if (this.ref.current) this.observer.observe(this.ref.current);
  }

  componentWillUnmount() {
    if (this.observer && this.ref.current) {
      this.observer.unobserve(this.ref.current);
    }
  }

  render() {
    const { children, delay = 0, className = "", enabled = true, style = {} } = this.props;
    const { visible } = this.state;

    if (!enabled) {
      return (
        <div className={className} style={style}>
          {children}
        </div>
      );
    }

    return (
      <div
        ref={this.ref}
        className={`${className} ${visible ? 'tw-animate-fade-up' : ''}`}
        style={{
          ...style,
          ...(visible ? { animationDelay: `${delay}s` } : {})
        }}
      >
        {children}
      </div>
    );
  }
}

export default FadeUpOnScroll;
